import { render } from "./BlockedUser.vue?vue&type=template&id=cf4b1e0e&scoped=true"
import script from "./BlockedUser.vue?vue&type=script&lang=js"
export * from "./BlockedUser.vue?vue&type=script&lang=js"

import "./BlockedUser.vue?vue&type=style&index=0&id=cf4b1e0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf4b1e0e"]])

export default __exports__